import clsx from 'clsx'
import type { FC } from 'react'
import React from 'react'

import LabelStyles from './Label.module.css'

export interface LabelProps extends React.HTMLAttributes<HTMLLabelElement> {
  htmlfor?: string
  children?: React.ReactNode
  className?: string
}

const Label: FC<LabelProps> = ({
  htmlfor,
  children,
  className,
}: LabelProps) => {
  return (
    <label
      className={clsx(LabelStyles['hnui-label-container'], className)}
      htmlFor={htmlfor}
    >
      {children}
    </label>
  )
}

Label.displayName = 'Label'

export default Label
